<script lang="ts">
    import { apiBaseURL } from "../config"
    import { navigate } from "svelte-routing"
    import { i18n, sprache } from "../store"
    import { zeroPad } from "../api"
    import Image from "./Image.svelte"

    export let item: Content
    export let template: string

    let datum = new Date(item.date)
    let day = zeroPad(datum.getDate(), 2)
    let month = datum.toLocaleString("default", { month: "short" })
    let year = datum.getFullYear()

    //let publishDate = new Date(item.publishDate)
    // let currentDate = new Date()
    //let isFuture = publishDate > currentDate

    let showTag = false
    let showedTag = ""
    if (item.tags_) {
        for (let tag of item.tags_) {
            let tagName = tag.name.de
            if (tagName.toUpperCase().startsWith("VDE")) {
                showTag = true
                showedTag = tagName
            }
        }
    }
</script>

{#if template == "news"}
    <!-- {#if !isFuture} -->
    <div class="grid-item">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
            class="item-header"
            on:click="{() => {
                navigate(item.path)
            }}"
        >
            {#if item.postImage?.src || item.mlpostImage}
                {#if item.postImage?.src}
                    <img
                        src="{!item.postImage?.src.startsWith('data:')
                            ? apiBaseURL + 'content/' + item.id + '/' + item.postImage?.src + '?filter=m'
                            : item.postImage?.src}"
                        alt="{item.title}"
                    />
                {:else}
                    <Image
                        imageId="{item.mlpostImage}"
                        image_="{item.mlpostImage_}"
                        apiBaseURL="{apiBaseURL}"
                        size="m"
                    />
                    <!-- <img
                        src="{!item.mlpostImage_?.file?.src?.startsWith('data:')
                            ? apiBaseURL +
                              'media/' +
                              item.mlpostImage_?._id +
                              '/' +
                              item.mlpostImage_?.file?.src +
                              '?filter=m'
                            : item.mlpostImage_?.file?.src}"
                        alt=""
                    /> -->
                {/if}
            {:else if item.heroImage?.src}
                <img
                    src="{!item.heroImage?.src.startsWith('data:')
                        ? apiBaseURL + 'content/' + item.id + '/' + item.heroImage?.src + '?filter=m'
                        : item.heroImage?.src}"
                    alt="{item.title}"
                />
            {:else}
                <Image imageId="{item.mlheroImage}" image_="{item.mlheroImage_}" apiBaseURL="{apiBaseURL}" size="m" />
                <!-- <img
                    src="{!item.mlheroImage_?.file?.src?.startsWith('data:')
                        ? apiBaseURL +
                          'media/' +
                          item.mlheroImage_?._id +
                          '/' +
                          item.mlheroImage_?.file?.src +
                          '?filter=m'
                        : item.mlheroImage_?.file?.src}"
                    alt=""
                /> -->
            {/if}

            <div class="datum"><span>{day}</span><span>{month}</span><span>{year}</span></div>
        </div>
        <div class="item-content">
            <h4>{item.title}</h4>
            {#if item.teaserText}{@html item.teaserText}{/if}
            <a href="{item.path}" class="icon chevron-left more">Weiterlesen</a>
        </div>
    </div>
    <!-- {/if} -->
{/if}
{#if template == "posts"}
    <div class="grid-item">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
            class="item-header"
            on:click="{() => {
                navigate(item.path)
            }}"
        >
            {#if item.postImage?.src || item.mlpostImage}
                {#if item.postImage?.src}
                    <img
                        src="{!item.postImage?.src.startsWith('data:')
                            ? apiBaseURL + 'content/' + item.id + '/' + item.postImage?.src + '?filter=m'
                            : item.postImage?.src}"
                        alt="{item.title}"
                    />
                {:else}
                    <Image
                        imageId="{item.mlpostImage}"
                        image_="{item.mlpostImage_}"
                        apiBaseURL="{apiBaseURL}"
                        size="m"
                    />
                    <!-- <img
                        src="{!item.mlpostImage_?.file?.src?.startsWith('data:')
                            ? apiBaseURL +
                              'media/' +
                              item.mlpostImage_?._id +
                              '/' +
                              item.mlpostImage_?.file?.src +
                              '?filter=m'
                            : item.mlpostImage_?.file?.src}"
                        alt=""
                    /> -->
                {/if}
            {:else if item.heroImage?.src}
                <img
                    src="{!item.heroImage?.src.startsWith('data:')
                        ? apiBaseURL + 'content/' + item.id + '/' + item.heroImage?.src + '?filter=m'
                        : item.heroImage?.src}"
                    alt="{item.title}"
                />
            {:else}
                <Image imageId="{item.mlheroImage}" image_="{item.mlheroImage_}" apiBaseURL="{apiBaseURL}" size="m" />
                <!-- <img
                    src="{!item.mlheroImage_?.file?.src?.startsWith('data:')
                        ? apiBaseURL +
                          'media/' +
                          item.mlheroImage_?._id +
                          '/' +
                          item.mlheroImage_?.file?.src +
                          '?filter=m'
                        : item.mlheroImage_?.file?.src}"
                    alt=""
                /> -->
            {/if}
            <div class="item-title"><h4>{item.title}</h4></div>
        </div>
        <div class="item-content">
            {#if item.teaserText}{@html item.teaserText}{/if}
            <a href="{item.path}" class="icon chevron-left more">Weiterlesen</a>
        </div>
    </div>
{/if}
{#if template == "sections"}
    <div class="post">
        <div class="post-header">
            <h2>{item.title}</h2>
            <h3>{item.subtitle}</h3>
            {#if item.tags && showTag}
                <!-- svelte-ignore a11y-label-has-associated-control -->
                <label>{showedTag}</label>
            {/if}
        </div>
        <div class="post-content">
            {#if item.teaserText}{@html item.teaserText}{/if}
            <a href="{item.path}" class="icon chevron-left more">Weiterlesen</a>
        </div>
    </div>
{/if}
{#if template == "stations"}
    <div class="grid-item">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
            class="item-header"
            on:click="{() => {
                navigate(item.path)
            }}"
        >
            {#if item.postImage?.src || item.mlpostImage}
                {#if item.postImage?.src}
                    <img
                        src="{!item.postImage?.src.startsWith('data:')
                            ? apiBaseURL + 'content/' + item.id + '/' + item.postImage?.src + '?filter=m'
                            : item.postImage?.src}"
                        alt="{item.title}"
                    />
                {:else}
                    <Image
                        imageId="{item.mlpostImage}"
                        image_="{item.mlpostImage_}"
                        apiBaseURL="{apiBaseURL}"
                        size="m"
                    />
                {/if}
            {:else if item.heroImage?.src}
                <img
                    src="{!item.heroImage?.src.startsWith('data:')
                        ? apiBaseURL + 'content/' + item.id + '/' + item.heroImage?.src + '?filter=m'
                        : item.heroImage?.src}"
                    alt="{item.title}"
                />
            {:else}
                <Image imageId="{item.mlheroImage}" image_="{item.mlheroImage_}" apiBaseURL="{apiBaseURL}" size="m" />
            {/if}
        </div>
        <div class="item-content">
            <h4>{item.title}</h4>
            <a href="{item.path}" class="icon chevron-left more">Weiterlesen</a>
        </div>
    </div>
{/if}
